<i18n>
{
	"en": {
		"title": "Select new stretch delivery party"

	},
	"no": {
		"title": "Velg strekninger"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		:isConfirmDisabled="!despatchParty.name"
		icon="order"
		iconColor="blue"
		width="400px"
		@close="$emit('close')"
		@ok="onConfirm"
	>
		<div class="dialog-mid">
			<GlobalAddressInput
				ref="despatchParty"
				:value="despatchParty"
				disableButtonTabbing
				focusNextOnSelected
				@change="onChangeDespatchParty"
			/>
		</div>
	</t-dialog>
</template>
<script>
import GlobalAddressInput from '@/modules/globalAddresses/GlobalAddressInput';

export default {
	name: 'AddSubOrderBefore',
	components: {
		GlobalAddressInput,
	},
	props: {
		isShown: Boolean,
		order: Object,
	},
	data() {
		return {
			despatchParty: {}
		};
	},
	methods: {
		onChangeDespatchParty(value) {
			this.despatchParty = value;
		},
		onConfirm() {
			this.$emit('addSubOrderBefore', { subOrder: this.order, despatchParty: this.despatchParty });
			this.despatchParty = {};
		}
	},
};
</script>